import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// CAMPAIGN APIS
// ================================

// 🔹 GET CAMPAIGN LIST
export async function getCampaignList(
  camp_user,
  camp_status = "",
  camp_platform = "",
  camp_cat = "",
  search_key = "",
  page = "0"
) {
  try {
    const fd = new FormData();
    fd.append("camp_user", camp_user);
    fd.append("camp_status", camp_status);
    fd.append("camp_platform", camp_platform);
    fd.append("camp_cat", camp_cat);
    fd.append("search_key", search_key);
    fd.append("page", page);

    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}campaignapis/getList`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCampaignList error:", error);
    return { status: false, type: "danger", success: "Failed to fetch campaigns" };
  }
}

// 🔹 UPDATE CAMPAIGN STATUS
export async function updateCampaignStatus(camp_id, camp_status) {
  try {
    const fd = new FormData();
    fd.append("camp_id", camp_id);
    fd.append("camp_status", camp_status);

    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}campaignapis/update_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("updateCampaignStatus error:", error);
    return { status: false, type: "danger", success: "Status update failed" };
  }
}

// 🔹 KPI STATS
export async function getCampaignKpiStats(camp_user) {
  try {
    const fd = new FormData();
    fd.append("camp_user", camp_user);

    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    const response = await axios.post(`${apiBaseUrl}campaignapis/kpi_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCampaignKpiStats error:", error);
    return { status: false, type: "danger", success: "Failed to load KPI stats" };
  }
}

// 🔹 CREATE CAMPAIGN
export async function createCampaign(
  camp_user,
  camp_id,
  camp_title,
  camp_desc,
  camp_cat,
  camp_link,
  camp_platform,
  camp_templete,
  camp_color,
  camp_logo = null,
  sequences = [],
  invites = [],
  invfile = null,
  aiReplyActive,
  brandMessage
) {
  try {
    const fd = new FormData();

    fd.append("camp_user", camp_user);
    fd.append("camp_id", camp_id);
    fd.append("camp_title", camp_title);
    fd.append("camp_desc", camp_desc);
    fd.append("camp_cat", camp_cat);
    fd.append("camp_link", camp_link);
    fd.append("camp_platform", camp_platform);
    fd.append("camp_templete", camp_templete);
    fd.append("camp_color", camp_color);
    fd.append("aiReplyActive", aiReplyActive);
    fd.append("brandMessage", brandMessage);

    fd.append("buss_id", JSON.parse(sessionStorage.getItem("myBuss")).buss_id);

    // ✅ Logo (optional)
    if (camp_logo) {
      fd.append("camp_logo", camp_logo);
    }
    if (invfile) {
      fd.append("invfile", invfile);
    }

    // ✅ Follow-up Sequences
    fd.append("sequences", JSON.stringify(sequences));
    fd.append("invites", JSON.stringify(invites));

    // ✅ Invite List
    fd.append("invites", JSON.stringify(invites));

    const response = await axios.post(
      `${apiBaseUrl}campaignapis/create_campaign`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;

  } catch (error) {
    console.error("createCampaign error:", error);

    return {
      status: false,
      type: "danger",
      success: "Campaign creation failed",
    };
  }
}

export async function getCampById(camp_id) {
  try {
    const fd = new FormData();
    fd.append("camp_id", camp_id);

    const response = await axios.post(`${apiBaseUrl}campaignapis/get_camp_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCampaignKpiStats error:", error);
    return { status: false, type: "danger", success: "Failed to load KPI stats" };
  }
}

export async function getGmbReviewLinks(uid) {
  try {

    const fd = new FormData();
    fd.append("uid", uid);

    const response = await axios.get(
      `${apiBaseUrl}gmb/review-links`,
      {
        params: { uid: uid }
      }
    );

    return response.data;

  } catch (error) {

    console.error("getGmbReviewLinks error:", error);

    return {
      status: false,
      type: "danger",
      success: "Failed to load Google Business locations"
    };

  }
}

export async function delCampNow(camp_id) {
  try {
    const fd = new FormData();
    fd.append("camp_id", camp_id);

    const response = await axios.post(`${apiBaseUrl}campaignapis/del_camp_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getCampaignKpiStats error:", error);
    return { status: false, type: "danger", success: "Failed to load KPI stats" };
  }
}

export async function sendReview(
  review_platform,
  review_camp,
  review_user,
  review_source,
  review_name,
  review_email,
  review_mobile,
  review_rating,
  review_feedback
) {
  try {

    const fd = new FormData();

    fd.append("review_platform", review_platform);
    fd.append("review_camp", review_camp);
    fd.append("review_user", review_user);
    fd.append("review_source", review_source);
    fd.append("review_name", review_name);
    fd.append("review_email", review_email);
    fd.append("review_mobile", review_mobile);
    fd.append("review_rating", review_rating);
    fd.append("review_feedback", review_feedback);


    const response = await axios.post(
      `${apiBaseUrl}campaignapis/sendReview`,
      fd,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;

  } catch (error) {

    console.error("sendReview error:", error);

    return {
      status: false,
      type: "danger",
      success: "Review submission failed",
    };
  }
}

export const getCampaignInvites = async (
  camp_id,
  page = "0"
) => {

  try {

    const fd = new FormData();

    fd.append("camp_id", camp_id);
    fd.append("page", page);

    const response = await axios.post(
      apiBaseUrl + "campaignapis/get-invites",
      fd
    );

    return response.data;

  } catch (error) {

    console.error("getCampaignInvites error:", error);

    return {
      status: false,
      invites: [],
      total: 0
    };
  }
};



